// src/features/records/components/MapView/components/RecordHoverCard.js
import { useTranslation } from 'react-i18next';
import { Calendar, MapPin, Tag } from 'lucide-react';
import { coerceDateValue, formatDate } from '../../../../../utils/dateUtils';
import styles from './RecordHoverCard.module.css';

const RecordHoverCard = ({ record }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;

  if (!record) return null;

  const { title = t('records.views.map.item.untitled'), body = '', tags = [] } = record.content || {};
  const locationName = record.attributes?.location?.name;
  const createdAt = record.metadata?.createdAt;
  const createdDate = coerceDateValue(createdAt);
  const createdAtLabel = createdDate
    ? formatDate(createdDate, {
        locale,
        t,
        formatOptions: {
          month: 'short',
          day: 'numeric',
          ...(createdDate.getFullYear() !== new Date().getFullYear()
            ? { year: 'numeric' }
            : {}),
        },
      })
    : null;

  // Truncate body for preview
  const truncateText = (text, maxLength = 80) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{title}</h3>
      
      {body && (
        <p className={styles.body}>{truncateText(body)}</p>
      )}
      
      <div className={styles.metadata}>
        {locationName && (
          <div className={styles.metaItem}>
            <MapPin className={styles.metaIcon} />
            <span className={styles.metaText}>{locationName}</span>
          </div>
        )}
        
        {createdAtLabel && (
          <div className={styles.metaItem}>
            <Calendar className={styles.metaIcon} />
            <span className={styles.metaText}>{createdAtLabel}</span>
          </div>
        )}
      </div>
      
      {tags.length > 0 && (
        <div className={styles.tags}>
          <Tag className={styles.tagIcon} />
          <div className={styles.tagList}>
            {tags.slice(0, 3).map((tag, index) => (
              <span key={index} className={styles.tag}>
                {tag}
              </span>
            ))}
            {tags.length > 3 && (
              <span className={styles.tagMore}>+{tags.length - 3}</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecordHoverCard;
